module.exports = __webpack_public_path__ + "static/media/computer.ca042db5.svg";